<template>
  <div class="draw_scroll" ref="scrollWrap">
    <div class="draw_list"
         infinite-scroll-immediate="false"
         v-if="!isLogin||draw_list.length==0">
      <div class="draw_list_item"
           v-for="(item,index) in sampleSysList"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="./img/icon_tool.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">工具箱</span>
                  <span class="tag">{{ toolList[relation].list[arrange - 1].title }}</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 @click="sampleDeleteDraw(item,index)">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac"
                 @click="down_draw_list('sample')">
                <i class="el-icon-download"></i><span>下载</span>
              </p>
            </div>
          </div>
          <div>
            <div class="big_img">
              <div class="msg_img_sample" v-if="relation<3">
                <el-image :src="item.img_url"
                          :preview-src-list="[item.raw_img_url]">
                </el-image>
              </div>
              <!--              <div class="msg_img_wrap">-->
              <!--                <el-image :src="item.img_url+'?width='+item.s_w+'&height='+item.s_h"-->
              <!--                          :preview-src-list="[item.raw_img_url]">-->
              <!--                </el-image>-->
              <!--              </div>-->
              <div class="msg_img_drawList" v-else>
                <div class="msg_img_wrap" v-if="relation==3">
                  <el-image style="display:block;max-width: 400px;"
                            :src=" item.iw_url"
                            :preview-src-list="[item.iw_url]">
                  </el-image>
                  <div class="left_img"><span>处理前</span></div>
                </div>
                <div class="arrow_icon">
                  <div>
                    <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="10"
                         height="10">
                      <path
                          d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z"
                          fill="#6e7173"></path>
                    </svg>
                  </div>
                </div>
                <div class="msg_img_wrap"
                     :class="toolList[relation].list[arrange - 1].mj_tool!='HeadExtraction'?'msg_img_width1':'msg_img_width2'">
                  <el-image style="display:block;max-width: 100%;height: auto;"
                            :src="item.img_url"
                            :preview-src-list="[item.img_url]">
                  </el-image>
                  <div @click.stop="ImageJump(item.img_url,item.s_w,item.s_h)" class="look_img">
                    {{ toolList[relation].list[arrange - 1].mj_tool != 'HeadExtraction' ? '查看原图' : '查看' }}
                  </div>
                  <div class="right_img"><span>处理后</span></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="draw_list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-disabled="noMore || loading">
      <div class="draw_list_item"
           v-for="(item,index) in draw_list"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="./img/icon_tool.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">工具箱</span>
                  <span class="tag">{{ toolList[relation].list[arrange - 1].title }}</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 v-if="item.status=='2'"
                 @click="down_draw_list('draw',item,index)">
                <i class="el-icon-download" style="font-size: 16px"></i><span>下载</span>
              </p>
              <p class="delete flex ac"
                 @click="delete_draw_list(item.draw_id, index)">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac" v-if="item.is_public==0"
                 @click="pulic_draw_item(item,index)">
                <i class="el-icon-position"></i><span>推荐到广场</span>
              </p>
              <p class="delete flex ac" style="color: #f0b132;"
                 v-else
                 @click="pulic_draw_item(item,index)">
                <i class="el-icon-position"></i><span>已推荐到广场</span>
              </p>
            </div>
          </div>
          <div class="create_error" v-if="item.status == 3">
            <img class="error_icon"
                 src="./img/image_error.png"
                 alt="">
            <div class="error_text">很遗憾，绘画失败 !</div>
            <div class="error_btn"
                 @click="showDefeatPopup">查看失败原因
            </div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
          </div>
          <template v-else-if="item.status < 2">
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text"
                   v-if="item.progress <= 0">正在全力出图中，请稍等...
              </div>
            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </template>
          <div v-else>
            <div class="tryonImg" v-if="item.img_type=='imgVirtualTryOn'">
              <div class="modelImg">
                <!-- <img :src="item.iw_url" alt=""> -->
                <el-image
                    :src="item.iw_url"
                    :preview-src-list="[item.iw_url]"
                    fit="cover"
                >
                </el-image>
              </div>
              <div class="addImg">
                <img src="./img/clJia.png" alt="">
              </div>
              <div class="modelImg">
                <el-image
                    :src="item.iw_urls||JSON.parse(item.parameters).iw_urls"
                    :preview-src-list="[JSON.parse(item.parameters).iw_urls]"
                    fit="cover"
                >
                </el-image>
                <!-- <img :src="item.iw_urls||JSON.parse(item.parameters).iw_urls" alt=""> -->
              </div>
              <div class="addImg">
                <img src="./img/clDeng.png" alt="">
              </div>
              <div class="modelImg">
                <el-image
                    :src="item.img_url"
                    :preview-src-list="[item.img_url]"
                    fit="cover"
                >
                </el-image>
              </div>
            </div>
            <div class="big_img"
                 v-if="item.img_url&&item.img_type!='imgVirtualTryOn'">
              <div class="msg_img_drawList" >
                <div class="msg_img_wrap">
                  <el-image style="display:block;max-width: 400px;"
                            :src=" item.iw_url"
                            :preview-src-list="[item.iw_url]">
                  </el-image>
                  <div class="left_img"><span>处理前</span></div>
                </div>
                <div class="arrow_icon">
                  <div>
                    <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="10"
                         height="10">
                      <path
                          d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z"
                          fill="#6e7173"></path>
                    </svg>
                  </div>
                </div>
                <div class="msg_img_wrap">
                  <el-image style="display:block;max-width: 100%;height: auto;"
                            :src="item.img_url"
                            :preview-src-list="[item.img_url]">
                  </el-image>

                  <div class="right_img"><span>处理后</span></div>
                </div>
              </div>

            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0 && item.status < 2">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么工具箱绘画会提示失败？</div>
            <div class="item_answer">
              答：因为工具箱绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>


    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>
    <popup ref="viewPopup"
           type="center"
           @close="popClose">
      <img class="view_img" alt=""
           :src="view_img_url"
           style="width:100% !important;height:100% !important;">
      <!-- <el-image style="display:block;max-width: 400px;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image> -->
    </popup>
    <canvas ref="localCanvas"
            style="display: none;"
            useCORS="true"
            allowTaint="true"></canvas>
    <el-image ref="previewImg" style="display: none;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import utils from "@/utils";


export default {
  components: {popup, circleloading, FeedBack, Recommend,},
  props: ['sampleList'],
  data() {
    return {
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗

      current_draw: null,//当前选中的记录
      draw_list: [],
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleTimer: null,
      view_img_url: "",
      page: 1,
      currentTimer: new Date(),
      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('./img/magnify.png'),
              title: '无损放大',
              mj_tool: 'Upscaler',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('./img/colour.png'),
              title: '黑白上色',
              mj_tool: 'Colorize',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('./img/repair.png'),
              title: '清晰增强',
              mj_tool: 'SharpnessEnhancement',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('./img/cartoon.png'),
              title: '风格转换',
              mj_tool: 'Painting',

            },
            {
              id: 5,
              relation: 0,
              name: '图像擦除',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('./img/removelog.png'),
              title: '图像擦除',
              mj_tool: 'imgRemove',
            },

          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('./img/capture.png'),
              title: '背景移除',
              mj_tool: 'BackgroundRemoval',
            },
            {
              id: 2,
              relation: 1,
              name: 'AI虚拟试衣  ',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/fittingRoom.jpg'),
              title: 'AI虚拟试衣 ',
              mj_tool: 'imgVirtualTryOn',
            },

          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('./img/expansion.png'),
              title: '头像提取',
              mj_tool: 'HeadExtraction',
            },
          ],
        },

        {
          title: 'AI变美', relation: 3, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              title: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('./img/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              title: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('./img/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              title: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('./img/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              title: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('./img/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              title: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('./img/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              title: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('./img/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              title: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('./img/beautify7.webp'),
              points: 1,
            },
            {
              id: 8,
              relation: 3,
              name: '人脸美颜',
              title: '人脸美颜',
              mj_tool: 'emitFacebeauty',
              guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
              img: require('./img/beautify8.webp'),
              points: 1,
            },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              title: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('./img/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              title: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('./img/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              title: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('./img/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation
    console.log("fetchDataList create")
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")

    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    fettchSampleList() {
      // 获取样例数据
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0


      const year = this.currentTimer.getFullYear();
      const month = String(this.currentTimer.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(this.currentTimer.getDate()).padStart(2, '0');
      const hours = String(this.currentTimer.getHours()).padStart(2, '0');
      const minutes = String(this.currentTimer.getMinutes()).padStart(2, '0');
      const seconds = String(this.currentTimer.getSeconds()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      if (this.sampleUserList.length > 0) {
        console.log('大于0')
        this.sampleSysList = this.sampleUserList
      } else {
        console.log('不大于0')
        this.$http.get('/front/aimj/mjtools/sample/', {
          params: {
            mj_tool: this.toolList[this.relation].list[this.arrange - 1].mj_tool,
            page: 1,
            size: 20,
          }
        }).then((res) => {
          console.log('/mjtools/sample/', res)

          if (res.status == 200) {
            this.sampleSysList = res.data
          }
        }).finally(() => {

        })

        // for (let i = 0; i < 5; i++) {
        //   let obj = {
        //     add_time:formattedDate,
        //     img_url:require('./img/Upscaler/'+this.toolList[this.relation].list[this.arrange - 1].mj_tool+'0'+(i+1)+'.png'),
        //   }
        //   this.sampleSysList.splice(i,0,obj)
        // }
      }
    },

    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('样例图片不可删除！', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {

      }).catch(() => {
      })
    },

    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get('/front/aimj/mjtools/', {
        params: {
          mj_tool: this.toolList[this.relation].list[this.arrange - 1].mj_tool,
          max_mj_id: this.max_mj_id
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1123123
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },

    fetchMsg() {
      let _this = this
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/mjtools/status/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              if (e.img_type == 'imgVirtualTryOn') {
                if (e.fail_reason == 'NO_PERSON' || e.fail_reason == 'NO_UPPER') {
                  this.$message({
                    type: 'warning',
                    message: "模特图片不符合要求，请按照示例上传",
                  })
                  clearInterval(_this.timer);
                }
              }
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.parameters = e.parameters
              item.show_error = e.show_error
              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                console.log("删除生成成功或失败的", e)
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.img_type == "imgVirtualTryOn" && e.status == 2) {
                item.img_type = 'imgVirtualTryOn'
                item.iw_url = e.iw_url
                item.img_url = e.img_url
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                // this.scrollToTop();
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.raw_img_url = e.raw_img_url
                item.iw_small_url = e.iw_small_url
                item.iw_url = e.iw_url
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 3000)
    },

    viewImg(item, type) {
      let img_url = item.raw_img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        // that.$refs.viewPopup.show();
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    previewImg(url) {
      this.view_img_url = url;
      this.$refs.viewPopup.show();
    },
    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.$http.delete(`/front/aimj/mjtools/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })
    },
    down_draw_list(type,item,index,position) {
      // 下载
      if(type=='sample'){
        this.$message.warning('当前样例禁止下载，请生成后重试')
      } else if(type=='video'){
        this.$http.get(`/front/aimj/draw/video/${item.draw_id}/`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }else{
        console.log('作品下载')
        this.$http.get(`/front/aimj/draw/down/${item.draw_id}/?${position!=undefined?'nano_position='+position:''}`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },

    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false;
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true;
        this.$refs.morePopover[index].doClose();
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
        console.log('Request Failed', error);
      }
    },

    clickImage(raw_img_url) {
      // 下载图片
      this.$nextTick(() => {
        let wrapper = document.getElementsByClassName(
            "el-image-viewer__actions__inner"
        );
        if (wrapper.length > 0) {
          let downImg = document.createElement("i");
          downImg.setAttribute("class", "el-icon-download");
          wrapper[0].appendChild(downImg);
          downImg.addEventListener("click", () => {
            console.log(raw_img_url)
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
              var canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              var context = canvas.getContext("2d");
              context.drawImage(image, 0, 0, image.width, image.height);
              var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = raw_img_url;
            //this.downloadImage(raw_img_url, "aaa")
            //这里写下载图片的方法
            // const content = document.querySelector('.el-image-viewer__img'); // 获取需要保存为图片的 DOM 元素
            // html2canvas(content).then(canvas => {
            //     setTimeout(() => {
            //         // 将 Canvas 转换为图片数据
            //         const imageData = canvas.toDataURL('image/png');
            //         // 创建一个 <a> 元素，并设置 href 属性为图片数据
            //         const a = document.createElement('a');
            //         a.href = imageData;
            //         a.download = Date.now() + '.png'; // 设置下载文件名
            //         a.click(); // 模拟点击下载
            //     }, 500)
            // },);
            // const canvas = this.$refs.localCanvas;
            // var imgRaw = new Image();
            // imgRaw.src = raw_img_url
            // imgRaw.setAttribute('crossOrigin', 'anonymous');
            // imgRaw.onload = function () {
            //     canvas.width = imgRaw.width
            //     canvas.height = imgRaw.height
            //     const ctx = canvas.getContext('2d');
            //     ctx.drawImage(imgRaw, 0, 0);
            //     const imageData = canvas.toDataURL('image/jpeg');
            //     const a = document.createElement('a');
            //     a.href = imageData;
            //     a.download = Date.now() + '.png'; // 设置下载文件名
            //     a.click(); // 模拟点击下载
            // }
          });
        }
      });
    },
    ImageJump(imgurl, s_w, s_h) {
      // window.open(imgurl + '?width=' + s_w + '&height=' + s_h, '_blank');
      window.open(imgurl, '_blank');
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.draw_scroll {
  background-color: #313338;
  // height: calc(100% - 31px);
  height: 100%;
  overflow-y: auto;
  color: #fff;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    width: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  .draw_list {
    overflow: hidden;
    width: 100%;
    position: relative;

    .draw_list_item {
      padding-bottom: 5px;
      background: #403d38;
      border-left: 2px solid #f0b132;
      margin: 10px 0;

      .text {
        padding: 10px;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;

        .title {

          border-bottom: 1px solid #555041;
          padding-bottom: 15px;
          margin-bottom: 20px;

          .info {
            //margin-bottom: 10px;
            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 7px;
              cursor: pointer;
            }

            .topic {
              font-size: 14px;
              margin-right: 10px;
            }

            .tag {
              background-color: #23a559;
              display: inline-block;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              border-radius: 4px;
              white-space: nowrap;
            }

            .time {
              color: #707070;
              font-size: 12px;
            }
          }

          .more_btn {
            width: 36px;
            height: 24px;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            background-color: #1e1f22;
          }

          .delete {
            cursor: pointer;
            margin-left: 8px;
            color: #949ba4;
            font-size: 12px;

            img {
              width: 20px;
              height: 20px;
              margin-top: -2px;

              &.share {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        .desc {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .en {
            padding-top: 10px;
            margin-top: 10px;
            color: #999168;
            border-top: 1px solid #555041;
          }
        }
      }

      .tryonImg {
        width: 100%;
        height: 167px;
        display: flex;
        align-items: center;
        background: rgb(43, 45, 49);

        .modelImg {
          // width: 162px;
          height: 116px;
          border-radius: 8px;
          margin: 0 14px;

          .el-image {
            width: 82px;
            height: 116px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .addImg {
          width: 14px;
          height: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .big_img {
        margin-top: 10px;
      }

      .options {
        .options_list {
          margin-top: 10px;

          .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
          }

          span {
            font-size: 13px;
            width: 58px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #4e5058;
            margin-left: 8px;
            border-radius: 3px;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
            }

            &:hover {
              background: #6e717c;
            }

            &.span {
              width: 100px;

              img {
                margin-right: 5px;
              }
            }

            &.span2 {
              width: 40px;
            }
          }

          //
          .redraw {
            img {
              height: 20px;
              // margin-top: 5px;
            }

            line-height: 32px;
          }

          .btn {
            // flex-grow: 1;
            // height: 32px;
            // line-height: 32px;
            // color: #18a058;
            // background-color: #dbefe4;
            // border-radius: 2px;
            // font-size: 12px;
            // font-weight: bold;
            // text-align: center;
            // cursor: pointer;
            // width: 0;
            &:not(:last-child) {
              margin-right: 0px;
            }

            &.loading {
              opacity: 0.6;

              svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
              }
            }

            &.redraw2 {
              background-color: #f5f6fb;

              img {
                height: 30px;
              }
            }

            &.disabled {
              cursor: not-allowed;
              background-color: #ddd;
              color: #666;
            }
          }

          //
        }
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 190px;
  min-height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
  .err_new_tip {
    color: #ccc;
    margin-top: 20px;
    padding:   0  0 20px;

    .err_tokf {
      color: red;
    }
  }
}

.defeat_popup {
  width: 300px;
  padding: 0 30px 36px;
  background-color: #333;
  border-radius: 10px;
  white-space: normal;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("./img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 100%;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_sample {
  max-width: 400px;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.msg_img_drawList {
  display: flex;

  .msg_img_wrap {
    flex: 1;
    max-width: 400px;
    object-fit: contain;
    position: relative;
    overflow: hidden;
    //background-image: url('./img/aiTool/img_bg.png');
    //margin-right: 10px;
    // border-radius:5px;
    .look_img {
      display: none;
      //opacity: 0;
      cursor: pointer;
      //width: 100px;
      padding: 0 10px;
      height: 36px;
      position: absolute;
      top: 10px;
      right: 10px;
      border: rgba(88, 101, 242, 0.8) solid 2px;
      background-color: rgba(88, 101, 242, 0.533);
      border-radius: 6px;
      color: white;
      font-size: 14px;
      box-sizing: border-box;
      line-height: 32px;
      text-align: center;
    }

    .left_img {
      position: absolute;
      top: 15px;
      left: 0;
      color: white;
      font-size: 12px;
      background-color: #00000091;
      border-top-right-radius: 100px; /* 右上角半圆 */
      border-bottom-right-radius: 100px; /* 右下角半圆 */
      padding: 3px 6px;

      span {
        margin: 0 5px;
      }

    }

    .right_img {
      position: absolute;
      top: 15px;
      right: 0;
      color: white;
      font-size: 12px;
      background-color: #00000091;
      border-top-left-radius: 100px; /* 右上角半圆 */
      border-bottom-left-radius: 100px; /* 右下角半圆 */
      padding: 3px 6px;

      span {
        margin: 0 5px;
      }

    }

    &:hover {
      .img_footer {
        bottom: 0;
      }
    }

    .msg_img_ele {
      display: block;
      width: 100%;
      cursor: pointer;
    }

    .img_footer {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: -40px;
      height: 40px;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: space-around;
      transition: bottom 0.3s;

      .footer_item {
        cursor: pointer;

        .footer_icon {
          display: inline-block;
          width: 14px;
          height: 14px;
          vertical-align: middle;
          margin-right: 5px;
          background-size: 100% 100%;

          &.download {
            background-image: url("./img/download.png");
          }

          &.preview {
            background-image: url("./img/preview_img.png");
          }

          &.delete {
            background-image: url("./img/remove.png");
          }
        }

        span {
          vertical-align: middle;
          display: inline-block;
          font-size: 14px;
          color: #fff;
        }
      }
    }

    // 图片上传
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      padding: 5px 5px;

    }

    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
      width: 100px !important;
      height: 100px !important;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      text-align: center;
    }

    .avatars {
      width: 100px;
      height: 100px;
      display: block;
      border: 1px dashed #d9d9d9;
    }

  }
}


.arrow_icon {
  width: 3px;
  background-color: #fff;
  position: relative;
  display: flex;

  div {
    position: absolute;
    z-index: 1;
    padding: 4px;
    background-color: #fff;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

//.msg_img_wrap {
//  max-width: 400px;
//  position: relative;
//  overflow: hidden;
//  display: inline-block;
//  background-image: url('./img/img_bg.png');
//  border-radius: 6px;
//  // border-radius:5px;
//  &:hover {
//    .img_footer {
//      bottom: 0;
//    }
//  }
//
//
//  .look_img {
//    //display: none;
//    //opacity: 0;
//    cursor: pointer;
//    width: 75px;
//    height: 28px;
//    position: absolute;
//    top: 10px;
//    right: 10px;
//    border: rgba(88, 101, 242, 0.8) solid 2px;
//    background-color: rgba(88, 101, 242, 0.533);
//    border-radius: 6px;
//    color: white;
//    font-size: 12px;
//    box-sizing: border-box;
//    line-height: 24px;
//    text-align: center;
//  }
//
//  /deep/ .el-image {
//    display: block;
//  }
//}

.more_list {
  .operate_item {
    height: 28px;
    font-size: 14px;
    color: #949ba4;

    img {
      width: 20px;
      height: 20px;
      margin-top: -2px;
      margin-right: 4px;

      &.share {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>